import styles from './O_CapsulePostHeader.module.css';
import A_CircleButton from '@/components/A_Atoms/A_CircleButton/A_CircleButton';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import Q_BlurEffect from '@/components/Q_Quarks/Q_BlurEffect/Q_BlurEffect';

interface O_CapsulePostHeaderProps {
  onToggleExpanded: () => void;
  isExpanded: boolean;
}

export default function O_CapsulePostHeader({
  onToggleExpanded,
  isExpanded,
}: O_CapsulePostHeaderProps) {
  return (
    <div className={styles.wrapper}>
      <Q_BlurEffect yAxis='top' />
      <A_CircleButton
        icon={<Q_Icon.CrossIcon width={24} height={24} fill='none' />}
        variant='secondary'
        onClick={() => {
          window.history.back();
        }}
      />
      <A_CircleButton
        icon={
          isExpanded ? (
            <Q_Icon.ExpandIcon width={24} height={24} fill='none' />
          ) : (
            <Q_Icon.ReduceIcon width={24} height={24} fill='none' />
          )
        }
        variant='secondary'
        onClick={onToggleExpanded}
      />
    </div>
  );
}
